<template>
  <div v-if="show === true" class="review-sheet" @click.stop>

    <div class="review-handle"></div>

    <div class="review-brand">
      <img
        v-if="brandLogoSrc"
        :src="brandLogoSrc"
        class="review-brand-logo"
        alt="brand"
      />
      <div v-else class="review-brand-text">
        {{ brandText }}
      </div>
    </div>

    <div class="review-title">
      Can you help us by<br>
      sharing your experience?
    </div>

    <div class="review-google">
      <div class="google-word">
        <span class="g-b">G</span><span class="g-r">o</span><span class="g-y">o</span><span class="g-b">g</span><span class="g-g">l</span><span class="g-r">e</span>
      </div>

      <div class="google-reviews-row">
        <div class="google-reviews-label">Reviews</div>
        <div class="google-stars">★★★★★</div>
      </div>
    </div>

    <div class="review-sub">
      Your opinion helps us grow
    </div>

    <button
      class="review-button"
      type="button"
      @click="onRateClick"
    >
      Rate on Google
    </button>

  </div>
</template>

<script>
export default {
  name: "GoogleReviewPrompt",
  props: {
    show: { type: Boolean, default: false },
    googleReviewUrl: { type: String, default: "" },
    brandText: { type: String, default: "oblique" },
    brandLogoSrc: { type: String, default: "" },
    zIndex: { type: [String, Number], default: 995 },
    closeOnOverlayClick: { type: Boolean, default: true },
  },
  emits: ["close", "rate"],
  methods: {
    onOverlayClick() {
      if (this.closeOnOverlayClick === true) {
        this.$emit("close");
      }
    },
    onRateClick() {
      this.$emit("rate");

      if (this.googleReviewUrl && this.googleReviewUrl.length > 0) {
        window.open(this.googleReviewUrl, "_blank", "noopener,noreferrer");
      }

      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* Sheet: now flows inside parent modal */
.review-sheet {
  width: 100%;
  background: #ffffff;
  border-radius: 18px 18px 0 0;
  padding: 12px 24px 26px 24px;
  padding-bottom: calc(26px + env(safe-area-inset-bottom));
}
/* Handle */
.review-handle {
  width: 52px;
  height: 5px;
  border-radius: 999px;
  background: #d8d8dd;
  margin: 6px auto 18px auto;
}

/* Brand */
.review-brand {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
}
.review-brand-text {
  font-size: 28px;
  font-style: italic;
  letter-spacing: 0.3px;
  color: #111;
}
.review-brand-logo {
  height: 28px;
}

/* Title */
.review-title {
  text-align: center;
  font-weight: 800;
  font-size: 28px;
  line-height: 32px;
  color: #111;
  margin-top: 8px;
  margin-bottom: 20px;
}

/* Google */
.review-google {
  text-align: center;
}
.google-word {
  font-size: 56px;
  font-weight: 800;
  line-height: 58px;
  letter-spacing: -1px;
}
.g-b { color: #4285F4; }
.g-r { color: #DB4437; }
.g-y { color: #F4B400; }
.g-g { color: #0F9D58; }

.google-reviews-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.google-reviews-label {
  font-size: 20px;
  font-weight: 700;
  color: #666;
}
.google-stars {
  font-size: 18px;
  color: #F4B400;
  letter-spacing: 2px;
}

/* Sub */
.review-sub {
  text-align: center;
  font-size: 17px;
  color: #666;
  margin-top: 16px;
  margin-bottom: 20px;
}

/* Button */
.review-button {
  width: 100%;
  height: 58px;
  border-radius: 999px;
  border: none;
  background: #f04b4b;
  color: #fff;
  font-size: 19px;
  font-weight: 800;
}
</style>